import assetPath from '/app/xinglets/companies/companies/src/assets/images/managed-empty-state.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')